import moment from 'moment';
import * as React from 'react';
import DateTimePicker from 'react-datetime';
import { Button, Col, Form, Modal, ModalProps, Row } from 'react-bootstrap';
import { applyChangeIfDateValid } from '../../../../../../utils/datepicker';

type Props = {
  loading: boolean;
  onAdd: (name: string, startDate: Date, endDate: Date) => void;
} & ModalProps;

const CreateModal = ({ show, onHide, onAdd, loading }: Props) => {
  const [name, setName] = React.useState('');
  const [startDate, setStartDate] = React.useState<Date>(moment().toDate());
  const [endDate, setEndDate] = React.useState<Date | null>();

  const handleSubmit = () => {
    if (!name.length) {
      alert('Please, enter valid name');
      return;
    }
    if (!endDate) {
      alert('Please, enter valid endDate');
      return;
    }
    onAdd(name, startDate, endDate);
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Body>
        <Row>
          <Col xs={3}>Name</Col>
          <Col xs={6}>
            <Form.Control
              name="diamondPrize"
              required
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={3}>Start date</Col>
          <Col xs={6}>
            <DateTimePicker onChange={applyChangeIfDateValid(setStartDate)} value={startDate} />
          </Col>
        </Row>
        <Row>
          <Col xs={3}>End date</Col>
          <Col xs={6}>
            <DateTimePicker onChange={applyChangeIfDateValid(setEndDate)} value={endDate ?? undefined} />
          </Col>
        </Row>
        <Row className="mt-3 pl-1">
          <Button disabled={loading} onClick={handleSubmit}>
            Add
          </Button>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default CreateModal;
